import { passAffiliateParams } from 'react-easyrocket';

export const getAffiliateData = () => {
  const affiliateData = passAffiliateParams();
  return Boolean(affiliateData.affiliate_id) && Boolean(affiliateData.affiliate_user_id);
};
